module.exports = __webpack_public_path__ + "img/feedback_list2.50d7b940.png";